import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c91284c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ListItemVue = _resolveComponent("ListItemVue")

  return (_openBlock(), _createBlock(_component_ListItemVue, {
    item: _ctx.state.hospitals,
    isDefaultDetail: _ctx.state.isDefaultDetail
  }, _createSlots({ _: 2 }, [
    (_ctx.isDefaultDetail)
      ? {
          name: "detail",
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, "detail", {}, undefined, true)
          ])
        }
      : undefined
  ]), 1032, ["item", "isDefaultDetail"]))
})